const yup = require("yup");
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

module.exports = yup
  .string()
  .matches(phoneRegExp, "Phone number is not valid")
  .required("Phone number is required");
